import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    canDelete: {
        defaultMessage: "Can Delete",
        id: "setup.queryExtraction.canDelete",
    },
    daily: {
        defaultMessage: "Daily",
        id: "setup.queryExtraction.daily",
    },
    dayOfMonth: {
        defaultMessage: "Day of Month",
        id: "setup.queryExtraction.dayOfMonth",
    },
    dayOfWeek: {
        defaultMessage: "Day of Week",
        id: "setup.queryExtraction.dayOfWeek",
    },
    deleteConfirmationMessage: {
        defaultMessage: "Are you sure you want to delete the selected Query Extraction?",
        id: "setup.queryExtraction.deleteConfirmation",
    },
    deleteConfirmationTitle: {
        defaultMessage: "Delete Confirmation",
        id: "setup.queryExtraction.deleteConfirmationTitle",
    },
    deleteSelectedButton: {
        defaultMessage: "Delete Selected",
        id: "setup.queryExtraction.deleteSelectedButton",
    },
    deleteSelectedConfirmationMessage: {
        defaultMessage:
            "WARNING!!!!  Clicking the Delete button below will permanently delete {count} Query Extractions!",
        id: "setup.queryExtraction.deleteSelectedConfirmationMessage",
    },
    description: {
        defaultMessage: "Description",
        id: "setup.queryExtraction.description",
    },
    fileName: {
        defaultMessage: "File Name",
        id: "setup.queryExtraction.fileName",
    },
    frequency: {
        defaultMessage: "Frequency",
        id: "setup.queryExtraction.frequency",
    },
    friday: {
        defaultMessage: "Friday",
        id: "setup.queryExtraction.friday",
    },
    invalidFileType: {
        defaultMessage: "The output file name must end in {fileNames}, or {endingFileName}",
        id: "setup.queryExtraction.invalidFileType",
    },
    invalidSqlHeader: {
        defaultMessage: "Invalid SQL Query",
        id: "setup.queryExtraction.invalidSqlHeader",
    },
    lastModified: {
        defaultMessage: "Last Modified",
        id: "setup.queryExtraction.lastModified",
    },
    monday: {
        defaultMessage: "Monday",
        id: "setup.queryExtraction.monday",
    },
    monthly: {
        defaultMessage: "Monthly",
        id: "setup.queryExtraction.monthly",
    },
    name: {
        defaultMessage: "Name",
        id: "setup.queryExtraction.name",
    },
    outputUrl: {
        defaultMessage: "Output Location URL",
        id: "setup.queryExtraction.outputUrl",
    },
    query: {
        defaultMessage: "Query",
        id: "setup.queryExtraction.query",
    },
    queryId: {
        defaultMessage: "Query ID",
        id: "setup.queryExtraction.queryId",
    },
    queryIdLabel: {
        defaultMessage: "Query ID",
        id: "setup.queryExtraction.queryIdLabel",
    },
    queryIsARequiredField: {
        defaultMessage: "Query text cannot be empty.",
        id: "setup.queryExtraction.queryIsARequiredField",
    },
    queryText: {
        defaultMessage: "Query",
        id: "setup.queryExtraction.queryText",
    },
    saturday: {
        defaultMessage: "Saturday",
        id: "setup.queryExtraction.saturday",
    },
    sunday: {
        defaultMessage: "Sunday",
        id: "setup.queryExtraction.sunday",
    },
    thursday: {
        defaultMessage: "Thursday",
        id: "setup.queryExtraction.thursday",
    },
    tuesday: {
        defaultMessage: "Tuesday",
        id: "setup.queryExtraction.tuesday",
    },
    validSqlHeader: {
        defaultMessage: "Validated SQL Query",
        id: "setup.queryExtraction.validSqlHeader",
    },
    validSqlText: {
        defaultMessage: "The Query has been validated and will execute.",
        id: "setup.queryExtraction.validSqlText",
    },
    validate: {
        defaultMessage: "Validate",
        id: "setup.queryExtraction.validate",
    },
    validationErrors: {
        defaultMessage: "Validation Errors",
        id: "setup.queryExtraction.validationErrors",
    },
    wednesday: {
        defaultMessage: "Wednesday",
        id: "setup.queryExtraction.wednesday",
    },
    weekly: {
        defaultMessage: "Weekly",
        id: "setup.queryExtraction.weekly",
    },
    fileExtention: {
        defaultMessage: "File Extention",
        id: "setup.queryExtraction.fileExtention",
    },
});
